import { useSelector } from "react-redux";

function useGetUserListColumnsConfiguration() {
  const columns = useSelector((rootState) => {
    return rootState.userList.columns;
  });

  return columns;
}

export default useGetUserListColumnsConfiguration;
